import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "30.838",
  height: "32.51"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "data-name": "Path 7875",
  d: "m17.121 24.214 3.546-3.546m3.546-3.546-3.546 3.546m0 0-3.546-3.546m3.546 3.546 3.546 3.546",
  transform: "translate(5.564 7.236)",
  style: {"fill":"none","stroke":"#fff","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5px"}
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  "data-name": "Path 7876",
  d: "M4 6v10.03s0 5.015 11.7 5.015 11.7-5.015 11.7-5.015V6",
  transform: "translate(-3.25 -.235)",
  style: {"fill":"none","stroke":"#fff","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5px"}
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  "data-name": "Path 7877",
  d: "M15.7 3c11.7 0 11.7 5.015 11.7 5.015s0 5.015-11.7 5.015S4 8.015 4 8.015 4 3 15.7 3z",
  style: {"fill":"none","stroke":"#fff","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5px"},
  transform: "translate(-3.25 -2.25)"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("path", {
  "data-name": "Path 7878",
  d: "M15.7 27.046C4 27.046 4 22.03 4 22.03V12",
  transform: "translate(-3.25 3.796)",
  style: {"fill":"none","stroke":"#fff","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5px"}
}, null, -1)
const _hoisted_6 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_6]))
}
export default { render };